import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { Save } from 'lucide-react';
import { STAT_GROUPS, DERIVED_LABELS } from './constants';

export const PerformanceStatistics = ({
  statsDraft, setStatsDraft, setStatsDirty, statsDirty, derived, perf,
  canEdit, statsSaving, onSave,
}) => (
  <div className="space-y-4">
    <p className="text-xs text-gray-500" data-testid="stats-hint">
      Leave a field blank if the metric was <b>not tracked</b>. Enter <b>0</b> only for a tracked zero.
    </p>
    {Object.keys(derived).length > 0 && (
      <Card data-testid="stats-derived">
        <CardHeader className="pb-2"><CardTitle className="text-base">Derived</CardTitle></CardHeader>
        <CardContent className="flex flex-wrap gap-2">
          {Object.entries(derived).map(([k, v]) => (
            <Badge key={k} className="bg-indigo-100 text-indigo-800 border-indigo-200" data-testid={`derived-${k}`}>
              {DERIVED_LABELS[k] || k}: {v}%
            </Badge>
          ))}
        </CardContent>
      </Card>
    )}
    {STAT_GROUPS.map(g => (
      <Card key={g.title} data-testid={`stats-group-${g.group}-${g.title.replace(/\W+/g, '-')}`}>
        <CardHeader className="pb-2"><CardTitle className="text-sm">{g.title}</CardTitle></CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {g.fields.map(([key, label]) => {
              const dk = `${g.group}.${key}`;
              return (
                <div key={dk}>
                  <Label className="text-xs">{label}</Label>
                  <Input type="number" min="0" placeholder="—"
                    disabled={!canEdit}
                    value={statsDraft[dk] ?? ''}
                    onChange={e => { setStatsDraft(d => ({ ...d, [dk]: e.target.value })); setStatsDirty(true); }}
                    data-testid={`stat-${g.group}-${key}`} />
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>
    ))}
    {canEdit && (
      <div className="flex items-center gap-3">
        <Button onClick={onSave} disabled={statsSaving || !statsDirty} data-testid="stats-save">
          <Save className="w-4 h-4 mr-1" /> Save Statistics
        </Button>
        {statsDirty && <span className="text-xs text-amber-600">Unsaved changes</span>}
      </div>
    )}
  </div>
);

export default PerformanceStatistics;
